import { Component, OnInit } from '@angular/core';
import { ParamsService } from 'src/app/services/params.service';
import { AppParam } from 'src/app/models/appparam.model';
import { ConfigKeys } from 'src/app/config/config.keys';
import { ShowCardService } from 'src/app/services/ShowCard.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {


  constructor(private paramsService: ParamsService, private showCardService: ShowCardService) {
    // subscribe to product component
    this.subscription = this.showCardService.getSelectedCard().subscribe(cardId => {
    if (cardId) {
      this.idCardSelected=Number(cardId.name);
      //console.log("HEADER SE SELECCIONO TARJETA------> " + cardId.name);
    } else {
    // clear product
     this.idCardSelected=1;
    }
    });
    }


  //------VARS FOR HEADER--------
  appParams: AppParam[] = [];

  paramBCWebSiteURL: string = "";
  paramBCWebSiteURLTarget: number = 2;

  paramReqCardURL: string[] = [];
  paramReqCardURLTarget: number[] = [];

  subscription: Subscription;

  idCardSelected: number=1;


  configKeys: ConfigKeys = new ConfigKeys();

  ngOnInit() {


    //var lastIdCard = this.route.snapshot.params['idCard'];
    //if(lastIdCard!='')
      // this.idCardSelected=lastIdCard;

      // console.log("LAST_ID_CARD_SELECTED(HEADER)----->" + this.idCardSelected);

    //console.log('ENTRANDO A OBTENER PARAMETROS----->');


    //--------FOR HEADER---------------
    this.paramsService.getAppParams().subscribe(
      (appParams: AppParam[]) => {
        this.appParams = appParams;
        this.paramsService.setAppParams(appParams);


        //-----------Set Parameter Values--------
        appParams.forEach(appParam => {

          if (appParam.cveParametro === this.configKeys.PARAM_BCOPPEL_URL) {
            this.paramBCWebSiteURL = appParam.valor;
            this.paramBCWebSiteURLTarget = appParam.target;
          }

          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL1) {
            this.paramReqCardURL[0] = appParam.valor;
            this.paramReqCardURLTarget[0] = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL2) {
            this.paramReqCardURL[1] = appParam.valor;
            this.paramReqCardURLTarget[1] = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL3) {
            this.paramReqCardURL[2] = appParam.valor;
            this.paramReqCardURLTarget[2] = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL4) {
            this.paramReqCardURL[3] = appParam.valor;
            this.paramReqCardURLTarget[3] = appParam.target;
          }

        });


      }
    );



  }


   //------ FOR HEADERS---------

   goToWebSite() {

    var url = this.paramBCWebSiteURL;

    if (2 === this.paramBCWebSiteURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }


  goToReqCard() {

    var url = this.paramReqCardURL[this.idCardSelected];

    var wtarget =  this.paramReqCardURLTarget[this.idCardSelected];

    if (2 === wtarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }



}
